var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{style:({background: _vm.$vuetify.theme.themes[_vm.theme].background})},[_c('default-app-bar'),_c('default-view'),_c('dialogs'),_c('loading'),_c('notifications',{attrs:{"position":"bottom right"}}),_c('vue-confirm-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }